angular.module('backstage.controllers.orgs', [])
    .controller('ListOrgsCtrl', require('./ListOrgsCtrl'))
    .controller('NewOrgCtrl', require('./NewOrgCtrl'))
    .controller('OrgViewCtrl', require('./OrgViewCtrl'));
